export default __webpack_public_path__ + "static/media/check.4461caaa.svg";